export default "__VITE_ASSET__BZtqvPnp__"